import { Link } from 'react-router-dom';
import { FeaturedProduct } from '../../../interface/interface';

const FeaturedProductCard = ({
  product,
  isGuest,
}: Readonly<{ product: FeaturedProduct; isGuest: boolean }>) => (
  <Link
    to={
      isGuest
        ? `/guest/product/${product.product_code}`
        : `/product/patient/${product.product_code}`
    }
    className="group flex h-full flex-col bg-white rounded-lg border border-grey-200 shadow-normal p-4 md:p-6
      bg-white p-4 transition-shadow duration-200 hover:shadow-md"
  >
    <div className="flex items-center justify-center">
      <img
        className="h-28 w-full object-contain md:h-32"
        src={product.image_url ?? '/default-image.png'}
        alt={product.name}
      />
    </div>

    <div className="mt-3 flex flex-col gap-1 text-left">
      <p className="text-xs font-semibold uppercase tracking-wide text-secondary-cornflowerblue-600 min-h-8">
        {product.product_brand}
      </p>
      <p className="text-sm font-regular text-primary-blue-500 line-clamp-2 min-h-9">
        {product.name}
      </p>
      <p className="text-xs text-grey-500">
        {product.weight}
        {product.unit}
      </p>
    </div>

    <div className="mt-4 flex items-baseline gap-2 justify-end">
      {product.old_price && (
        <span className="text-xs text-grey-500 line-through">
          ${product.old_price}
        </span>
      )}
      <span className="text-xl font-semibold text-primary-blue-500">
        ${product.price}
      </span>
    </div>
  </Link>
);

export default FeaturedProductCard;
